<!--
 * @Descripttion: 未完结订单
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="unfinished-order-list">
    <xrk-table
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    >
      <template #tableAfter>
        <div class="unfinished-order-tips-wrap">
          <div class="unfinished-order-tips">
            <div class="unfinished-order-title">已选中订单数量</div>
            <div class="unfinished-order-money">
              {{ tipsInfoData.orderNum }}个
            </div>
          </div>

          <div class="unfinished-order-tips">
            <div class="unfinished-order-title">订单支付总金额</div>
            <div class="unfinished-order-money">
              {{ formatter.fen2yuan(tipsInfoData.orderAmount, '元') }}
            </div>
          </div>

          <div v-if="!PLATFORM_IS_FEIGON" class="unfinished-order-tips">
            <div class="unfinished-order-title">含待支付平台服务费</div>
            <div class="unfinished-order-money">
              {{
                formatter.fen2yuan(tipsInfoData.platformServiceFeeAmount, '元')
              }}
            </div>
          </div>

          <div v-if="!PLATFORM_IS_FEIGON" class="unfinished-order-tips">
            <div class="unfinished-order-title">含待支付商务服务费</div>
            <div class="unfinished-order-money">
              {{
                formatter.fen2yuan(tipsInfoData.businessServiceFeeAmount, '元')
              }}
            </div>
          </div>
          <div class="unfinished-order-tips">
            <div class="unfinished-order-title">含待支付技术服务费</div>
            <div class="unfinished-order-money">
              {{
                formatter.fen2yuan(tipsInfoData.techServiceFeeTotalAmount, '元')
              }}
            </div>
          </div>
        </div>
      </template>
    </xrk-table>
  </div>
</template>

<script lang="tsx" setup>
import { ref, computed, onMounted, watch, nextTick } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseButton,
  XrkTableRef,
  createDialog,
  BaseTable,
  XrkMessage,
  XrkMessageBox
} from 'xrk-components';
import { formatter } from '@/utils';

import {
  noPayOrderPageList,
  noPayOrderCheckStatistics
} from '../data-source/apis';
import {
  orderNoCol,
  projectNameCol,
  projectNoCol,
  terminalTypeCol,
  taxCollectionPatternCol,
  entpNameCol,
  supplierNameCol,
  orderTimeCol,
  orderTypeCol,
  payTypeCol,
  payPassagewayCol,
  orderPriceCol,
  payStatusCol
} from '../fields/columns';
import {
  orderNoSearch,
  terminalTypeSearch,
  projectNameSearch,
  projectNoSearch,
  taxCollectionPatternSearch,
  entpNameSearch,
  supplierNameSearch,
  orderTypeSearch,
  orderTimeAtSearch,
  payTypeSearch,
  payPassagewayNameSearch,
  payStatusSearch
} from '../fields/searchs';
import { ORDER_PAY_STATUS, ORDER_PAY_STATUS_PAY_SUCCESS } from '../constants';
import PayInfoConfirm from './pay-info-confirm.vue';
import emitter from '../utils/event-bus';
import { IS_PLATFORM_TYPE_1, PLATFORM_IS_FEIGON } from '@/config';

const xrkTableRef = ref<XrkTableRef>();
const router = useRouter();
const route = useRoute();

const onRefreshTabel = (clearSelectionRows = false) => {
  xrkTableRef.value?.initCurrentList();
  clearSelectionRows && xrkTableRef.value?.clearSelectionRows();
};

const selectionVal = computed(() => {
  return xrkTableRef.value?.getSelectionRows();
});
const taxType = computed(() => {
  return route.meta.taxType as number;
});
onMounted(() => {
  emitter.on('refresh-order-tabel', () => {
    onRefreshTabel(true);
  });
});

// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置',
    beforeReset: () => {
      // 清除路由上的查询参数
      if (route.query.orderNo) {
        router.replace({
          query: { force: Date.now() }
        });
      }
    }
  },
  searchColumns: [
    { ...orderNoSearch, defaultValue: route.query.orderNo },
    projectNameSearch,
    projectNoSearch,
    { ...payPassagewayNameSearch, defaultValue: 'fyBank' },
    taxType.value === 1 && terminalTypeSearch,
    IS_PLATFORM_TYPE_1 && taxCollectionPatternSearch,
    entpNameSearch,
    taxType.value === 1 && supplierNameSearch,
    orderTypeSearch,
    orderTimeAtSearch,
    payTypeSearch,
    payStatusSearch
  ].filter(Boolean),
  otherComponents: [
    {
      render() {
        return (
          <>
            <BaseButton
              v-resource={[['未完结订单_发起支付']]}
              type="primary2"
              onClick={() => {
                if (!selectionVal.value.length) {
                  XrkMessage.error('请选择一条数据');
                  return;
                }
                createDialog({
                  title: '支付信息确认',
                  showFooter: false,
                  contentRender: done => {
                    return (
                      <div style="padding: 20px">
                        <PayInfoConfirm
                          done={done}
                          payInfo={selectionVal.value}
                          taxType={taxType.value}
                        />
                      </div>
                    );
                  }
                });
              }}
            >
              发起支付
            </BaseButton>
          </>
        );
      }
    }
  ]
});
const needSearch = ref(true);
const onSelectItems = async rows => {
  // 删除选中行
  const removeSelectionRows = () => {
    rows.forEach((item: any) => {
      xrkTableRef.value.removeSelectionRow(item[selectKey]);
    });
  };
  const searchItems = searchedParams.value;
  if (
    rows.length > 1 &&
    needSearch.value &&
    (!searchItems.payType || !searchItems.payPassagewayCode)
  ) {
    XrkMessageBox.alert(
      '当前状态不支持批量操作，请先选择【支付方式】和【支付通道】搜索后操作',
      '提示'
    );
    removeSelectionRows();
    return;
  }
  try {
    const { data } = await noPayOrderCheckStatistics({
      aspOrderIdList: selectionVal.value.map(item => item.aspOrderId)
    });
    const dataList = rows
      .map(item => {
        return (item.orderType === 1 && item.feeList) || [];
      })
      .flat()
      .filter(Boolean);
    if (!dataList.length) {
      tipsInfoData.value = data;
      return;
    }
    createDialog({
      title: '提示',
      width: 800,
      showClose: false,
      contentRender: () => {
        return (
          <div style="padding: 20px">
            <span>您勾选的订单，有关联的服务费需要同步支付，请确认。</span>
            <BaseTable
              style="min-height: 300px"
              ref="baseTableRef"
              data={dataList as any[]}
              columns={[
                projectNameCol,
                orderTimeCol,
                orderTypeCol,
                orderPriceCol
              ]}
            ></BaseTable>
          </div>
        );
      },
      async beforeConfirm(done) {
        tipsInfoData.value = data;
        needSearch.value = false;
        dataList.forEach(row => {
          xrkTableRef.value.addSelectionRow(row[selectKey], row);
        });
        nextTick(() => {
          needSearch.value = true;
        });
        done();
      },
      beforeCancel(done) {
        done();
        removeSelectionRows();
      }
    });
  } catch (error) {
    removeSelectionRows();
  }
};

const selectKey = 'idAndOrderType';

const tipsInfoData = ref({
  orderNum: 0, //已选订单数量（项目服务费+平台服务费+商务服务费）
  orderAmount: 0, //订单总金额（项目服务费+平台服务费+商务服务费）
  platformServiceFeeAmount: 0, //平台服务费订单总金额
  businessServiceFeeAmount: 0, //商务服务费订单总金额
  techServiceFeeTotalAmount: 0 //技术服务费订单总金额
});

watch(
  () => selectionVal.value,
  async (v, oldV) => {
    if (!v.length) {
      tipsInfoData.value = {
        orderNum: 0,
        orderAmount: 0,
        platformServiceFeeAmount: 0,
        businessServiceFeeAmount: 0,
        techServiceFeeTotalAmount: 0
      };
      return;
    }

    if (oldV.length > v.length) {
      // 取消选中
      const { data } = await noPayOrderCheckStatistics({
        aspOrderIdList: v.map(item => item.aspOrderId)
      });
      tipsInfoData.value = data;
      // 将本次取消选中的数据筛选出来将关联的服务费清空
      const ids = v.map(item => item[selectKey]);
      const selections = oldV.filter(item => {
        return !ids.includes(item[selectKey]);
      });
      selections.forEach(item => {
        if (item.orderType === 1 && item.feeList.length > 0) {
          item.feeList.forEach(feeItem => {
            xrkTableRef.value.removeSelectionRow(feeItem[selectKey]);
          });
        }
      });
      return;
    }
    // 将本次选中的数据筛选出来
    const ids = oldV.map(item => item[selectKey]);
    const selections = v.filter(item => {
      return !ids.includes(item[selectKey]);
    });
    onSelectItems(selections);
  }
);
console.log(IS_PLATFORM_TYPE_1, 'IS_PLATFORM_TYPE_1');
// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: '_selection',
      prop: selectKey,
      align: 'center',
      fixed: 'left',
      selectionDisabled(row) {
        // 项目服务费或者订单状态为待支付、支付失败 才允许支付
        return !(row.orderType === 1 && [0, 4].includes(+row.payStatus));
      },
      width: 120
    }),
    useTableColumn({
      type: 'index',
      label: '序号'
    }),
    orderNoCol,
    projectNameCol,
    projectNoCol,
    terminalTypeCol,
    IS_PLATFORM_TYPE_1 && taxCollectionPatternCol,
    entpNameCol,
    taxType.value === 1 && supplierNameCol,
    orderTimeCol,
    orderTypeCol,
    payPassagewayCol,
    payTypeCol,
    orderPriceCol,
    {
      ...payStatusCol,
      formatter({ cellValue, row }) {
        if (row.orderType === 1) {
          // 项目服务费
          return ORDER_PAY_STATUS?.[cellValue]?.label || '-';
        }
        return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
      }
    },
    useTableColumn({
      align: 'center',
      fixed: 'right',
      label: '操作',
      width: 250,
      render({ row }) {
        const pathMapDetailB = {
          1: '/main/asp/unfinished-order/detail-b',
          2: '/main/asp/unfinished-labor-order/detail-b'
        };
        const pathMapDetailC = {
          1: '/main/asp/unfinished-order/detail-c',
          2: '/main/asp/unfinished-labor-order/detail-c'
        };
        const pathMapDetailS = {
          1: '/main/asp/unfinished-order/detail-s',
          2: '/main/asp/unfinished-labor-order/detail-s'
        };
        const isSupplierOrder = row.projectStructureType === 1;
        const path = isSupplierOrder
          ? pathMapDetailB[taxType.value]
          : pathMapDetailC[taxType.value];
        return (
          <>
            <div>
              {
                // 项目费用才有修改
                row.orderType === 1 && [0, 4].includes(row.payStatus) && (
                  <BaseButton
                    v-resource={[['未完结订单_修改订单']]}
                    disabled={[1, 3].includes(row.payStatus)}
                    onClick={async () => {
                      // 修改
                      const routeData = router.resolve({
                        path,
                        query: {
                          aspOrderId: row.aspOrderId,
                          sceneType: row.sceneType,
                          projectStructureType: row.projectStructureType,
                          isEdit: 1
                        }
                      });
                      window.open(routeData.href);
                    }}
                    type="text"
                  >
                    修改
                  </BaseButton>
                )
              }
              <BaseButton
                v-resource={[['未完结订单_查看明细']]}
                onClick={async () => {
                  // 查看明细
                  if (row.orderType === 1) {
                    //项目费用查看明细
                    const routeData = router.resolve({
                      path,
                      query: {
                        aspOrderId: row.aspOrderId,
                        projectStructureType: row.projectStructureType,
                        sceneType: row.sceneType,
                        isEdit: 0
                      }
                    });
                    window.open(routeData.href);
                  } else {
                    // 商务/平台服务费查看明细
                    const routeData = router.resolve({
                      path: pathMapDetailS[taxType.value],
                      query: {
                        orderId: row.id,
                        orderType: row.orderType,
                        gysx:
                          row.industryId && +row.industryId > 0
                            ? +!row?.isVirtualIndustry
                            : 0,
                        taxPattern: row.taxPattern
                      }
                    });
                    window.open(routeData.href);
                  }
                }}
                type="text"
              >
                查看明细
              </BaseButton>
            </div>
          </>
        );
      }
    })
  ].filter(Boolean),
  baseConfig: { rowKey: selectKey }
});
const searchedParams = ref();

const getListAjax = async params => {
  const [orderStartTime, orderEndTime] = params.orderTime || ['', ''];

  const reqData = {
    ...params,
    orderStartTime,
    orderEndTime
  };
  const data = await noPayOrderPageList(reqData);
  searchedParams.value = reqData;
  return data;
};
</script>
<style lang="scss">
.unfinished-order-tips-wrap {
  display: flex;
  align-items: center;
  gap: 0 98px;
  margin: 24px 0 0 40px;

  .unfinished-order-tips {
    display: flex;
    align-items: center;

    .unfinished-order-title {
      font-size: 14px;
      color: #697077;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .unfinished-order-money {
      font-weight: 600;
      font-size: 14px;
      color: #121619;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
}
</style>
